import React, {useEffect, useState, useCallback, useMemo} from 'react';
import '../Carta.css';
import './Carta/CartaRedesign.css';
import iconoGenerico from '../iconoGenerico.svg';
import iconoFooter from '../logoFooter.svg';
import {
  Search,
  ShoppingCart,
  SubtractAlt,
  TrashCan
} from '@carbon/icons-react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { IoIosArrowBack } from "react-icons/io";
import { IoCall, IoLocationSharp } from "react-icons/io5";
import { AiFillInstagram } from "react-icons/ai";
import { FaSquareFacebook } from "react-icons/fa6";
import { IoReceiptOutline, IoArrowUpSharp } from "react-icons/io5";
import { useRef } from 'react';
import debounce from 'lodash.debounce';
import ProductListSkeleton from './Carta/components/ProductListSkeleton';
import VirtualizedProductListByCategory from './Carta/components/VirtualizedProductListByCategory';
import VirtualizedProductList from './Carta/components/VirtualizedProductList';
import ProductDetailModal from './Carta/components/ProductDetailModal';
import CartaBulkSaleModal from './Carta/components/CartaBulkSaleModal';
import { formatBulkQuantity, formatPricePerUnit, isBulkCatalogProduct } from '../utils/bulkSaleUtils';
import { isMobileDevice, openWhatsAppChat } from '../utils/whatsappUtils';
import {
  restoreWhatsappOrderSuccessModalIfNeeded,
  savePendingWhatsappOrderSuccess,
  showWhatsappOrderSuccessModal,
} from '../utils/cartaWhatsappOrderSuccess';
import { getApiErrorMessage } from '../utils/apiErrorUtils';
// React Query hooks
import { useShopBranches } from '../hooks/useShopBranches';
import { useCategoriesPaginated, useFlattenedCategories } from '../hooks/useCategoriesPaginated';
import { useBranchConfig } from '../hooks/useBranchConfig';
import { useCartaConfigSync } from '../hooks/useCartaConfigSync';
import { useBranchFeatures } from '../hooks/useBranchFeatures';
import { connectWebSocketForBranch } from '../config/WebsocketService';
import { queryClient, queryKeys } from '../config/queryClient';
import { useSocialMedia } from '../hooks/useSocialMedia';
import { useBanners } from '../hooks/useBanners';
import { useLogoImage } from '../hooks/useLogoImage';
import { useCategoryColor } from '../hooks/useCategoryColor';
// Hook de carrito con batching
import { usePersistedCart } from '../hooks/usePersistedCart';
import {
  formatPromotionLabel,
  getCartLineOriginalSubtotal,
  getCartLineSubtotal,
  getCartPromotionDiscount,
} from '../utils/productPromotion';
import { buildGeolocationValidateUrl } from '../utils/geolocationUtils';
import { isModuleActive, MODULE_NAMES } from '../utils/moduleUtils';

export default function Carta() {

  //flechas
  const categoriesRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [showBranchSelector, setShowBranchSelector] = useState(true);
  const [subdomain, setSubdomain] = useState('');
  const [shopBranchs, setShopBranchs] = useState([]);
  const [branchConfig, setBranchConfig] = useState(null);
  const [showError, setShowError] = useState(false);
  const [branchFeatures, setBranchFeatures] = useState([]);

  const [showInfo, setShowInfo] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [scrollTopVisible, setScrollTopVisible] = useState(false);
  const [cartDockVisible, setCartDockVisible] = useState(false);
  const [cartBarInDom, setCartBarInDom] = useState(false);
  const [productDetail, setProductDetail] = useState(null);
  const [bulkModalProduct, setBulkModalProduct] = useState(null);

  const [categories, setCategories] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);

  const [instagram, setInstagram] = useState('');
  const [facebook, setFacebook] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const [imageSrc, setImageSrc] = useState('');
  const [colorshop, setColorShop] = useState('#000000');
  const [nameShopBranch, setNameShopBranch] = useState('');
  const [phoneShopBranch, setPhoneShopBranch] = useState('');
  const [address, setAddress] = useState('');
  const [longitude, setLongitude] = useState('');
  const [latitude, setLatitude] = useState('');
  const [nameCategorySelected, setNameCategorySelected] = useState('');

  const [productsForCategory, setProductsForCategory] = useState([]);

  const [searchProducts, setSearchProducts] = useState([]);
  const [searchCategoriesWithProducts, setSearchCategoriesWithProducts] = useState([]);
  const [searching, setSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  const [allProducts, setAllProducts] = useState(true);
  const allProductsText = "TODOS LOS PRODUCTOS";

  const [dataProductsPedidoModal, setDataProductsPedidoModal] = useState([]);
  const [observationsPedido, setObservationsPedido] = useState('');

  //datos de envio
  const [nameAndSuername, setNameAndSuername] = useState('');
  const [isDelivery, setIsDelivery] = useState(false);
  const [streetAddress, setStreetAddress] = useState('');
  const [numberAddress, setNumberAddress] = useState('');
  const [localidadDirection, setLocalidadDirection] = useState('');
  const [floorAddress, setFloorAddress] = useState('');
  const [deptoAddress, setDeptoAddress] = useState('');
  const [observationsAddress, setObservationsAddress] = useState('');
  const [imagesBanners, setImagesBanners] = useState([]);

  // Estados de validaciones activas/inactivas
  const [isAddressValid, setIsAddressValid] = useState(false);
  const [lastValidatedAddress, setLastValidatedAddress] = useState({});

  // chequea si tiene habilitada la feature de negocio GEOLOCALIZACION
  const googleLocalizationFeature = branchFeatures.find(
      (feature) => feature.name === 'GEOLOCALIZACION' && feature.status === true
  );
  const ruralSettingsFeatures = branchFeatures.find(feature => feature.name === 'ZONA RURAL');
  const [shippingPrice, setShippingPrice] = useState(0.0);
  // fin chequea si tiene habilitada la feature de negocio GEOLOCALIZACION

  const [isRuralDelivery, setIsRuralDelivery] = useState(false);

  const SendOrderType = {
    A_DOMICILIO: { label: "A domicilio", value: 1 },
    RETIRO_LOCAL: { label: "Retira en local", value: 2 }
  };

  const OrderType = {
    WHATSAP: { label: "WhatsApp", value: 1 },
    EN_MESA: { label: "En Mesa", value: 2 },
    DELIVERY: { label: "Delivery", value: 3 },
    A_DISTANCIA: { label: "A Distancia", value: 4 }
  };

  // ==========================================
  // REACT QUERY HOOKS - Reemplazan llamadas imperativas
  // ==========================================
  
  // Obtener sucursales por subdominio
  const { 
    data: shopBranchesData, 
    isLoading: isLoadingBranches, 
    error: errorBranches 
  } = useShopBranches(subdomain);

  const loadMoreRef = useRef(null);

  // Catálogo paginado (carga progresiva por scroll)
  const categoriesPaginatedQuery = useCategoriesPaginated(selectedBranch?.id, null, 20, {
    refetchOnWindowFocus: false,
  });
  const {
    isLoading: isLoadingCategoriesQuery,
    error: errorCategories,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = categoriesPaginatedQuery;
  const categoriesData = useFlattenedCategories(categoriesPaginatedQuery);

  // Obtener configuración de la sucursal
  const {
    data: branchConfigData,
    isLoading: isLoadingConfig
  } = useBranchConfig(selectedBranch?.id);

  useCartaConfigSync(selectedBranch?.id);

  // Obtener features de la sucursal (también antes de elegir sucursal para validar módulos del negocio)
  const branchIdForFeatures = selectedBranch?.id || shopBranchs[0]?.id;
  const {
    data: branchFeaturesData,
    isLoading: isLoadingFeatures
  } = useBranchFeatures(branchIdForFeatures);

  // Obtener redes sociales
  const {
    data: socialMediaData
  } = useSocialMedia(selectedBranch?.id);

  // Obtener banners
  const {
    data: bannersData
  } = useBanners(selectedBranch?.id);

  // Obtener logo
  const {
    data: logoUrl
  } = useLogoImage(selectedBranch?.id);

  // Obtener color
  const {
    data: categoryColorData
  } = useCategoryColor(selectedBranch?.id);

  // Sincronizar datos de React Query con estados locales
  useEffect(() => {
    if (shopBranchesData) {
      setShopBranchs(shopBranchesData);
      setShowError(false);
    } else if (errorBranches) {
      setShowError(true);
    }
  }, [shopBranchesData, errorBranches]);

  useEffect(() => {
    const handleScroll = () => setShowScrollTop(window.scrollY > 320);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const restorePendingModal = () => {
      restoreWhatsappOrderSuccessModalIfNeeded(colorshop);
    };

    restorePendingModal();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        restorePendingModal();
      }
    };

    window.addEventListener('pageshow', restorePendingModal);
    window.addEventListener('focus', restorePendingModal);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('pageshow', restorePendingModal);
      window.removeEventListener('focus', restorePendingModal);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [colorshop]);

  useEffect(() => {
    if (!showScrollTop) {
      setScrollTopVisible(false);
      return undefined;
    }

    const frame = requestAnimationFrame(() => {
      setScrollTopVisible(true);
    });

    return () => cancelAnimationFrame(frame);
  }, [showScrollTop]);

  useEffect(() => {
    if (categoriesData && Array.isArray(categoriesData) && categoriesData.length > 0) {
      // Filtrar categorías inválidas (que tengan productDTOList válido)
      const validCategories = categoriesData.filter(
        cat => cat &&
               cat.productDTOList &&
               Array.isArray(cat.productDTOList)
      );
      if (validCategories.length > 0) {
        setCategories(validCategories);
        setNameCategorySelected(allProductsText);
      }
    }
  }, [categoriesData]);

  useEffect(() => {
    setIsLoadingCategories(isLoadingCategoriesQuery);
  }, [isLoadingCategoriesQuery]);

  useEffect(() => {
    if (branchConfigData) {
      setBranchConfig(branchConfigData);
    }
  }, [branchConfigData]);

  useEffect(() => {
    if (!selectedBranch?.id || !selectedBranch?.shopId) {
      return undefined;
    }

    connectWebSocketForBranch(selectedBranch.shopId, selectedBranch.id, (newConfig) => {
      queryClient.setQueryData(queryKeys.branchConfig(selectedBranch.id), (prev) => (
        typeof newConfig === 'function' ? newConfig(prev || {}) : newConfig
      ));
      setBranchConfig((prev) => (
        typeof newConfig === 'function' ? newConfig(prev || {}) : newConfig
      ));
    });

    return undefined;
  }, [selectedBranch?.id, selectedBranch?.shopId]);

  useEffect(() => {
    if (branchFeaturesData) {
      setBranchFeatures(branchFeaturesData);
    }
  }, [branchFeaturesData]);

  useEffect(() => {
    if (socialMediaData) {
      const instagram = socialMediaData.find(red => red.socialMediaType === "INSTAGRAM");
      const facebook = socialMediaData.find(red => red.socialMediaType === "FACEBOOK");
      const phone = socialMediaData.find(red => red.socialMediaType === "PHONENUMBER");
      
      setInstagram(instagram?.socialMediaLink || '');
      setFacebook(facebook?.socialMediaLink || '');
      setPhoneNumber(phone?.socialMediaLink || '');
    }
  }, [socialMediaData]);

  useEffect(() => {
    if (bannersData) {
      setImagesBanners(bannersData);
    }
  }, [bannersData]);

  useEffect(() => {
    if (logoUrl) {
      setImageSrc(logoUrl);
    }
  }, [logoUrl]);

  useEffect(() => {
    if (categoryColorData) {
      setColorShop(categoryColorData);
    }
  }, [categoryColorData]);

  useEffect(() => {
    if (!loadMoreRef.current || !hasNextPage || isFetchingNextPage || searching) {
      return undefined;
    }

    const observer = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting) {
        fetchNextPage();
      }
    }, { rootMargin: '240px' });

    observer.observe(loadMoreRef.current);
    return () => observer.disconnect();
  }, [fetchNextPage, hasNextPage, isFetchingNextPage, searching, categories.length]);

  useEffect(() => {
    if (!debouncedSearchTerm || !hasNextPage || isFetchingNextPage) {
      return;
    }
    fetchNextPage();
  }, [debouncedSearchTerm, hasNextPage, isFetchingNextPage, fetchNextPage]);

  // Búsqueda local en los datos ya cargados (sin llamada al backend, sin límite de resultados)
  const localSearchResults = useMemo(() => {
    if (!debouncedSearchTerm || debouncedSearchTerm.trim() === '' || !categories.length) {
      return { allCategories: [], categoryProducts: [] };
    }

    const term = debouncedSearchTerm.toLowerCase().trim();

    const allCategoriesFiltered = categories
      .map(cat => ({
        ...cat,
        productDTOList: (cat.productDTOList || []).filter(p =>
          p && (
            (p.name && p.name.toLowerCase().includes(term)) ||
            (p.description && p.description.toLowerCase().includes(term))
          )
        )
      }))
      .filter(cat => cat.productDTOList && cat.productDTOList.length > 0);

    const categoryProducts = (productsForCategory || []).filter(p =>
      p && (
        (p.name && p.name.toLowerCase().includes(term)) ||
        (p.description && p.description.toLowerCase().includes(term))
      )
    );

    return { allCategories: allCategoriesFiltered, categoryProducts };
  }, [debouncedSearchTerm, categories, productsForCategory]);

  // Sincronizar resultados de búsqueda local con estados de UI
  useEffect(() => {
    if (debouncedSearchTerm.trim() === '') {
      setSearching(false);
      setSearchCategoriesWithProducts([]);
      setSearchProducts([]);
      return;
    }

    if (allProducts) {
      setSearchCategoriesWithProducts(localSearchResults.allCategories);
    } else {
      setSearchProducts(localSearchResults.categoryProducts);
    }
    setSearching(true);
  }, [localSearchResults, debouncedSearchTerm, allProducts]);

  // ==========================================
  // FIN REACT QUERY HOOKS
  // ==========================================

  // Hook del carrito con batching de localStorage
  const [cart, setCart, cartHelpers] = usePersistedCart(selectedBranch?.id);
  const cartRef = useRef(cart);
  cartRef.current = cart;
  const hasAutoSelectedSingleBranchRef = useRef(false);

  const catalogProductById = useMemo(() => {
    const map = new Map();
    (categories || []).forEach((cat) => {
      (cat.productDTOList || []).forEach((product) => {
        if (product?.id != null) {
          map.set(product.id, product);
        }
      });
    });
    return map;
  }, [categories]);

  useEffect(() => {
    if (!catalogProductById.size) return;
    cartHelpers.reconcileWithCatalog(catalogProductById);
  }, [catalogProductById]);

  const cartItemCount = cart.reduce((sum, p) => sum + (p.bulkSale ? 1 : p.cant), 0);
  const showCartDock = cartItemCount > 0 && branchConfig?.status;
  const cartBarMounted = showCartDock || cartBarInDom;
  const showBottomDock = showScrollTop || cartBarMounted;
  const hasCartDockSpacing = cartBarMounted;

  useEffect(() => {
    if (!showCartDock) {
      setCartDockVisible(false);
      return undefined;
    }

    setCartBarInDom(true);

    const frame = requestAnimationFrame(() => {
      setCartDockVisible(true);
    });

    return () => cancelAnimationFrame(frame);
  }, [showCartDock]);

  useEffect(() => {
    if (showCartDock || !cartBarInDom) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setCartBarInDom(false);
    }, 280);

    return () => window.clearTimeout(timer);
  }, [showCartDock, cartBarInDom]);

  useEffect(() => {
    if (showBranchSelector) return undefined;

    const modalEl = document.getElementById('modalProductsPedido');
    if (!modalEl) return undefined;

    const cleanupModalUi = () => {
      modalEl.classList.remove('carta-v7-order-modal-root--closing');
      document.body.classList.remove(
        'carta-v7-order-modal-open',
        'carta-v7-order-modal--closing',
        'modal-open'
      );
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');

      if (!document.querySelector('.modal.show')) {
        document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
      }
    };

    const handleShow = () => {
      modalEl.classList.remove('carta-v7-order-modal-root--closing');
      document.body.classList.remove('carta-v7-order-modal--closing');
      document.body.classList.add('carta-v7-order-modal-open');
      setDataProductsPedidoModal(cartRef.current);
    };

    const handleHide = () => {
      modalEl.classList.add('carta-v7-order-modal-root--closing');
      document.body.classList.add('carta-v7-order-modal--closing');
    };

    const handleHidden = () => {
      modalEl.classList.remove('carta-v7-order-modal-root--closing');
      document.body.classList.remove('carta-v7-order-modal--closing');
      cleanupModalUi();
    };

    modalEl.addEventListener('show.bs.modal', handleShow);
    modalEl.addEventListener('hide.bs.modal', handleHide);
    modalEl.addEventListener('hidden.bs.modal', handleHidden);

    return () => {
      modalEl.removeEventListener('show.bs.modal', handleShow);
      modalEl.removeEventListener('hide.bs.modal', handleHide);
      modalEl.removeEventListener('hidden.bs.modal', handleHidden);
      modalEl.classList.remove('carta-v7-order-modal-root--closing');
      cleanupModalUi();
    };
  }, [showBranchSelector]);

  // ==========================================

  const validateAddress = async () => {
    if (!selectedBranch) return;

    const localId = selectedBranch.shopId;
    const shopBranchId = selectedBranch.id;
    const baseUrl = process.env.REACT_APP_API_LOCALIZATION_VALIDATE_ROUTE;

    const address = `${streetAddress} ${numberAddress}`;
    const encodedAddress = encodeURIComponent(address);
    const encodedLocality = encodeURIComponent(localidadDirection);
    if (streetAddress && numberAddress && localidadDirection && localId && shopBranchId) {
      try {
        const validateUrl = buildGeolocationValidateUrl(
          localId,
          shopBranchId,
          `${streetAddress} ${numberAddress}`,
          localidadDirection
        );
        if (!validateUrl) {
          return;
        }
        const response = await fetch(validateUrl, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'X-Geolocation-Key': process.env.REACT_APP_API_KEY_GEOLOCATION,
          }
        });

        if (response.ok) {
          const data = await response.json();
          const { valid, message, shippingPrice, isOutOfRange } = data;

          if (valid === true) {
            showAlert({
              title: 'Dirección validada',
              text: `La dirección ha sido validada correctamente. Precio de envío: ${formatPrice(shippingPrice) || 'N/A'}`,
              icon: 'success'
            });
            setShippingPrice(shippingPrice);
            setIsAddressValid(true);
            setLastValidatedAddress({
              streetAddress,
              numberAddress,
              localidadDirection,
            });
          } else {
            showAlert({
              title: 'Error de validación:',
              text: message,
              icon: 'error'
            });
            setIsAddressValid(false);
            if (isOutOfRange) {
              showAlert({
                title: 'Error de validación:',
                text: message,
                icon: 'error'
              });
            }
          }
        }
      } catch (error) {
        showAlert({
          title: 'Error de conexión:',
          text: 'Hubo un problema al validar la dirección.',
          icon: 'error'
        });
        setIsAddressValid(false);
        throw error;
      }
    }
  };

  //el precio base de los delivery
  function getDeliveryPriceBase(config, isRuralDelivery) {
    // Verificar si la entrega es rural
    if (isRuralDelivery) {
      return config.priceRuralBase || 0;
    }

    // Si no es rural, revisa el tipo de entrega
    switch (config.deliveryType) {
      case 'COMMON':
        return config.deliveryCommon?.priceBase || 0;
      case 'CUSTOM':
        return shippingPrice;
      default:
        return 0;
    }
  }

  const toggleRuralDelivery = (isChecked) => {
    setIsRuralDelivery(isChecked);
    if (isChecked) {
      setShippingPrice(branchConfig.priceRuralBase);
      cleanErrorSendPedidoWithoutDeliveryReset();
    } else {
      const newPrice = formatPrice(getDeliveryPriceBase(branchConfig));
      setShippingPrice(newPrice);
    }
  };


  // Detecta si la dirección ha cambiado después de la validación
  const checkAddressChange = () => {
    const hasChanged =
        streetAddress !== lastValidatedAddress.streetAddress ||
        numberAddress !== lastValidatedAddress.numberAddress ||
        localidadDirection !== lastValidatedAddress.localidadDirection;

    if (hasChanged) {
      setIsAddressValid(false);
    }
  };

  const showAlert = ({ title, text, icon, confirmButton = true }) => {
    Swal.fire({
      title,
      text,
      icon,
      showConfirmButton: confirmButton,
      confirmButtonColor: colorshop,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
    });
  };

  const getAllCategories = (branch) => {
    if (!branch) return;

    setIsLoadingCategories(true);
    axios.get(process.env.REACT_APP_API_CATEGORIES_PRODUCTS_ROUTE_CACHED, {
      params: {
        shopBranchId: branch.id,
      }
    })
        .then(response => {
          setCategories(response.data);
          setNameCategorySelected(allProductsText);
        })
        .catch(error => {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: getApiErrorMessage(error, 'No se pudieron cargar las categorías'),
          });
        })
        .finally(() => {
          setIsLoadingCategories(false);
        });
  }

  useEffect(() => {
    if (!selectedBranch?.id || isLoadingCategoriesQuery) {
      return;
    }
    if (categoriesData?.length > 0 || categories.length > 0) {
      return;
    }
    getAllCategories(selectedBranch);
  }, [selectedBranch?.id, isLoadingCategoriesQuery, categoriesData?.length, categories.length, errorCategories]);

  const getRedes = (shopBranchId) => {
    if (!shopBranchId) return;

    axios.get(process.env.REACT_APP_API_SOCIALMEDIA_ROUTE, {
      params: {
        status: true,
        shopBranchId: shopBranchId
      }
    })
        .then(response => {
          getValueRedPhoneNumber(response.data);
          getValueRedInstagram(response.data);
          getValueRedFacebook(response.data);
        })
        .catch(error => {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: getApiErrorMessage(error, 'No se pudieron cargar las redes sociales'),
          });
        });
  }

  const getAllImagesBanners = (shopBranchId) => {
    axios.get(process.env.REACT_APP_API_BANNER_IMAGES_GET_ROUTE + "/" + shopBranchId, {
    })
        .then(response => {
          setImagesBanners(response.data);
        })
        .catch(error => {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: getApiErrorMessage(error, 'No se pudieron cargar los banners'),
          });
        });
  }

  const getLogoImage = (shopBranchId) => {
    axios.get(process.env.REACT_APP_API_SHOP_ROUTE_UPDATE_LOGO_IMAGE + "/" + shopBranchId, {
      responseType: "blob",
    })
        .then((response) => {
          if(response.data.size !== 0){
            const imageBlob = response.data;
            const imageURL = URL.createObjectURL(imageBlob);
            setImageSrc(imageURL);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: getApiErrorMessage(error, 'Error cargando la imagen del logo'),
          })
        })
  }

  const getCategoryColor = (shopBranchId) => {
    if (!shopBranchId) return;

    axios.get(process.env.REACT_APP_API_SHOP_ROUTE_UPDATE_CATEGORY_COLOR + "/" + shopBranchId)
        .then((response) => {
          setColorShop(response.data);
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: getApiErrorMessage(error, 'No se pudo cargar el color de la categoría'),
          });
        });
  }

  const getShopBranches = (subdomain) => {
    axios.get(process.env.REACT_APP_API_SHOP_SUBDOMAIN_ROUTE, {
      params: {
        subdomain: subdomain
      }
    })
        .then(response => {
          const shopBranchsData = response.data;
          if (shopBranchsData && shopBranchsData.length > 0) {
            setShopBranchs(shopBranchsData);
            setShowError(false);
          } else {
            setShowError(true);
          }
        })
        .catch(error => {
          console.error(error);
          setShowError(true);
        });
  }

  const getBranchConfig = async (shopBranchId) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_MODULES_CONFIGS_CARTA_ROUTE, {
        params: {
          shopBranchId: shopBranchId
        }
      });
      if (response.data) {
        setBranchConfig(response.data);
      }
    } catch (error) {
      console.error('Error al obtener la configuración de la sucursal:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: getApiErrorMessage(error, 'No se pudo cargar la configuración de la sucursal'),
      });
    }
  };

  const getBranchFeatures = async (shopBranchId) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_FEATURE_SELECTOR_CARTA_ROUTE, {
        params: {
          shopBranchId: shopBranchId
        }
      });
      if (response.data) {
        setBranchFeatures(response.data);
      }
    } catch (error) {
      console.error('Error al obtener las features de la sucursal:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: getApiErrorMessage(error, 'No se pudieron cargar las características de la sucursal'),
      });
    }
  };

  const handleBranchSelection = (branch) => {
    setSelectedBranch(branch);
    setShowBranchSelector(false);
    queryClient.removeQueries({ queryKey: ['categoriesPaginated', branch.id] });

    // Datos de la sucursal (no requieren API)
    setNameShopBranch(branch.name);
    setPhoneShopBranch(branch.phoneNumber);
    setAddress(branch.address);
    setLongitude(branch.longitude);
    setLatitude(branch.latitude);

    // Carga inmediata del catálogo (el hook paginado complementa con scroll)
    getAllCategories(branch);
  }

  // Selección automática cuando hay solo una sucursal (solo al cargar, no al volver atrás)
  useEffect(() => {
    if (hasAutoSelectedSingleBranchRef.current) return;

    if (shopBranchs.length === 1 && !isLoadingBranches && !showError && !selectedBranch && showBranchSelector) {
      hasAutoSelectedSingleBranchRef.current = true;
      handleBranchSelection(shopBranchs[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopBranchs, isLoadingBranches, showError, selectedBranch, showBranchSelector]);

  const isDevDemoProd = (subdomain) => {
    return ['-dev', '-demo', '-qreate'].some(suffix => subdomain.endsWith(suffix));
  };

  //flechas
  const checkScroll = () => {
    const container = categoriesRef.current;
    if (!container) return;

    const { scrollLeft, scrollWidth, clientWidth } = container;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
  };

  useEffect(() => {
    document.title = 'CARTA';

    const hostname = window.location.hostname; // ej. "celumania.localhost" o "local1-demo.ucoode.com.ar"
    const firstPart = hostname.split('.')[0];  // ej. "celumania" o "local1-demo"

    let subdomain;

    if (hostname.includes('localhost')) {
      // En local, tomar todo lo que está antes del primer punto
      subdomain = firstPart;
    } else if (isDevDemoProd(firstPart)) {
      // En dev, demo o prod: tomar lo que está antes del primer guion "-"
      subdomain = firstPart.split('-')[0];
    } else {
      // Caso general (sin sufijo especial), tomar todo lo que está antes del primer punto
      subdomain = firstPart;
    }

    setSubdomain(subdomain);
    // getShopBranches ahora es manejado por el hook useShopBranches
  }, []); // Solo ejecutar una vez al montar

  useEffect(() => {
    const container = categoriesRef.current;
    if (!container) return;

    const handleWheel = (event) => {
      if (container.scrollWidth <= container.clientWidth) return;
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

      event.preventDefault();
      container.scrollLeft += event.deltaY;
    };

    checkScroll();
    container.addEventListener('scroll', checkScroll);
    container.addEventListener('wheel', handleWheel, { passive: false });
    window.addEventListener('resize', checkScroll);

    const resizeObserver = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(checkScroll)
      : null;
    resizeObserver?.observe(container);

    return () => {
      container.removeEventListener('scroll', checkScroll);
      container.removeEventListener('wheel', handleWheel);
      window.removeEventListener('resize', checkScroll);
      resizeObserver?.disconnect();
    };
  }, [categories]);

  const scrollCategories = (direction) => {
    const container = categoriesRef.current;
    if (!container) return;
    const scrollAmount = direction === 'left' ? -300 : 300;
    container.scrollBy({
      left: scrollAmount,
      behavior: 'smooth',
    });
    setTimeout(checkScroll, 300);// Le damos un pequeño delay para que scrollBy se ejecute y luego chequeamos
  };

  const getValueRedInstagram = (redes) => {
    let instagram = redes && redes.find(red => red.socialMediaType === "INSTAGRAM");
    if(instagram != null){
      setInstagram(instagram.socialMediaLink);
    }
  }

  const getValueRedFacebook = (redes) =>{
    let facebook = redes && redes.find(red => red.socialMediaType === "FACEBOOK");
    if(facebook != null){
      setFacebook(facebook.socialMediaLink);
    }
  }

  const getValueRedPhoneNumber = (redes) =>{
    let phoneNumber = redes && redes.find(red => red.socialMediaType === "PHONENUMBER");
    if(phoneNumber != null){
      setPhoneNumber(phoneNumber.socialMediaLink);
    }
  }

  const fillProductsByIdCategorySelected = (idCategory) => {
    setProductsForCategory([]);  // Inicializar con array vacío
    setSearchTerm('');  // Limpiar búsqueda (el hook se encarga automáticamente)
    
    // Validar que categories sea un array válido
    if (!categories || !Array.isArray(categories)) {
      setProductsForCategory([]);
      return;
    }
    
    const categoria = categories.find(cat => cat && cat.id === idCategory);
    
    // Validar que la categoría existe y tiene productDTOList válido
    if (categoria && categoria.productDTOList && Array.isArray(categoria.productDTOList)) {
      setProductsForCategory(categoria.productDTOList);
    } else {
      setProductsForCategory([]); // Asegurar array vacío, nunca undefined
    }
  }

  const fillAllProducts = () => {
    setProductsForCategory([]);  // Inicializar con array vacío
    setSearchTerm('');  // Limpiar búsqueda (el hook se encarga automáticamente)
  }

  // Debounce de 300ms para no filtrar en cada tecla
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);

    // Si el término está vacío, limpiar inmediatamente sin debounce
    if (searchTerm.trim() === '') {
      clearTimeout(timer);
      setDebouncedSearchTerm('');
      setSearching(false);
      setSearchCategoriesWithProducts([]);
      setSearchProducts([]);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    
    // Si está vacío, limpiar búsqueda inmediatamente
    if (value.trim() === '') {
      setDebouncedSearchTerm('');
      setSearching(false);
      setSearchCategoriesWithProducts([]);
      setSearchProducts([]);
    }
  };

  // Función legacy para búsqueda en categoría específica (fallback si backend falla)
  const filterProductsInCategory = (texto) => {
    return productsForCategory.filter(product =>
        product.name.toLowerCase().includes(texto.toLowerCase())
    );
  }

  function formatPrice(price) {
    if (price == null || isNaN(price)) return '';
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(price);
  }

  // ==========================================
  // FUNCIONES DEL CARRITO (usando hook con batching)
  // ==========================================

  // Función legacy para compatibilidad (ahora usa el hook)
  const getCartProducts = () => {
    return cart;
  };

  // Agregar producto al carrito (memoizado para evitar re-renders)
  const addProdPedido = useCallback((newProd) => {
    if (!selectedBranch) return;
    const catalogProduct = catalogProductById.get(newProd.id) || newProd;
    if (isBulkCatalogProduct(catalogProduct) || isBulkCatalogProduct(newProd)) {
      setBulkModalProduct(catalogProduct);
      return;
    }
    cartHelpers.addProduct(catalogProduct);
  }, [selectedBranch, cartHelpers, catalogProductById]);

  const confirmBulkAddToCart = useCallback((payload) => {
    if (!bulkModalProduct) return;
    cartHelpers.addBulkLine(bulkModalProduct, payload);
    setBulkModalProduct(null);
  }, [bulkModalProduct, cartHelpers]);

  // Quitar producto del carrito (memoizado para evitar re-renders)
  const minusProdPedido = useCallback((idProduct) => {
    if (!selectedBranch) return;
    cartHelpers.removeProduct(idProduct);
  }, [selectedBranch, cartHelpers]);

  // Eliminar producto completamente (memoizado para evitar re-renders)
  const deleteProductPedido = useCallback((productOrId) => {
    if (!selectedBranch) return;
    if (productOrId && typeof productOrId === 'object') {
      if (productOrId.cartLineId) {
        cartHelpers.deleteCartLine(productOrId.cartLineId);
        return;
      }
      cartHelpers.deleteProduct(productOrId.id);
      return;
    }
    cartHelpers.deleteProduct(productOrId);
  }, [selectedBranch, cartHelpers]);

  // Obtener cantidad de un producto (memoizado para evitar re-renders)
  const contProd = useCallback((idProduct) => {
    if (!selectedBranch) return '0';
    const lines = cart.filter((p) => p.id === idProduct);
    if (lines.length === 0) return '0';
    if (lines[0].bulkSale) {
      return String(lines.filter((p) => p.bulkSale).length);
    }
    return String(lines[0].cant ?? 0);
  }, [selectedBranch, cart]);

  // Sincronizar cart con dataProductsPedidoModal
  useEffect(() => {
    setDataProductsPedidoModal(cart);
  }, [cart]);

  // Calcular total del carrito (ahora usa helper del hook)
  const calcularTotal = (productos) => {
    return cartHelpers.calculateTotal();
  };

  const cleanPedidoBorrador = () => {
    Swal.fire({
      title: '¿Estás seguro de borrar el pedido?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Borrar',
      confirmButtonColor: colorshop,
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        cleanPedido();
      } else {
        const botonCarrito = document.getElementById('btnCarrito');
        botonCarrito.click();
      }
    });
  };

  const cleanPedido = () => {
    if (!selectedBranch) return;
    // clearCart() persiste [] en localStorage de forma inmediata (sin debounce)
    cartHelpers.clearCart();
    // Limpiar el campo de observaciones del modal del carrito
    setObservationsPedido('');
    // Cerrar el modal #modalDataForPedido si está abierto (flujo "Enviar pedido").
    // Este botón oculto tiene data-bs-dismiss + llama a cleanErrorSendPedido() que resetea
    // nameAndSuername y los errores del formulario. Es no-op si el modal ya está cerrado.
    const btnClosePersona = document.getElementById('btnCloseModalPersona');
    if (btnClosePersona) btnClosePersona.click();
  };

  // Función reutilizable para mostrar errores de campo
  const showFieldError = (selectorError, selectorInput) => {
    const fieldRequiredElement = document.querySelector(selectorError);
    const inputElement = document.getElementById(selectorInput);
    if (fieldRequiredElement && inputElement) {
      fieldRequiredElement.style.display = 'block';
      inputElement.style.border = '1px solid #ff1717';
    }
  };

  const sendOrderForWhatsapp = () => {
    const isNameInvalid = !nameAndSuername?.trim();

    const isDeliveryInvalid = isDelivery && !isRuralDelivery && (
        !streetAddress?.trim() ||
        !numberAddress?.trim() ||
        !localidadDirection?.trim()
    );

    if (isNameInvalid || isDeliveryInvalid) {
      if (isNameInvalid) {
        showFieldError('.errorNameAndSurname', 'nameAndSurname');
      }

      if (isDelivery && !isRuralDelivery) {
        if (!streetAddress?.trim()) {
          showFieldError('.errorStreetAddress', 'streetAddress');
        }
        if (!numberAddress?.trim()) {
          showFieldError('.errorNumberAddress', 'numberAddress');
        }
        if (!localidadDirection?.trim()) {
          showFieldError('.errorLocalidadDirection', 'localidadDirection');
        }
      }
      return;
    }

    if (isDelivery && !isRuralDelivery && branchConfig?.verifyAddress && !isAddressValid) {
      showAlert({
        title: 'Error de dirección',
        text: 'La dirección ha cambiado o no ha sido validada. Por favor, validá la dirección antes de continuar.',
        icon: 'error',
      });
      return;
    }

    confirmarEnvioPedido();
  };


  const confirmarEnvioPedido = () => {
    Swal.fire({
      title: '¿Enviar pedido?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      confirmButtonColor: colorshop,
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        if (!branchConfig?.status) {
          Swal.fire({
            title: 'Por el momento ya no tomamos más pedidos',
            text: "Gracias por tu comprensión, ¡te esperamos la próxima!",
            icon: 'error',
            showConfirmButton: true,
            allowOutsideClick: false,
            confirmButtonColor: colorshop,
            allowEscapeKey: false,
            allowEnterKey: false,
          }).then((result) => {
            if (result.isConfirmed) {
              const btnCloseModalCarrito = document.getElementById('btnCloseCarrito');
              btnCloseModalCarrito.click();
              const btnCloseModalDatosPersona = document.getElementById('btnCloseModalPersona');
              btnCloseModalDatosPersona.click();
            }
          });
        } else {
          let orderNumber = Date.now();
          sendOrder(orderNumber)
              .then(() => {
                // Llamamos a WhatsApp solo si sendOrder fue exitoso y si esta activa la notificacion por wpp
                if(branchConfig.messageWppActive){
                  createAndSendMessagePedidoWhatsapp(orderNumber);
                }else{
                  Swal.fire({
                    icon: 'success',
                    title: '¡Creado!',
                    html: `
                          <p>El pedido fue enviado con éxito. <br> 
                          <strong>Nro de pedido:</strong> <span id="orderNumber">${orderNumber}</span></p>
                          <p style="color: "#7c7c7c"; font-weight: 500;">⚠ No olvides guardar tu número de pedido.</p>
                          <button id="copyBtn" style="padding: 5px 10px; border-radius: 5px; cursor: pointer;">
                            Copiar número
                          </button>
                        `,
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                    didOpen: () => {
                      const copyBtn = Swal.getPopup().querySelector("#copyBtn");
                      copyBtn.addEventListener("click", (event) => {
                        event.stopPropagation(); // Evita que el Swal se cierre

                        const orderText = document.getElementById("orderNumber").innerText;
                        navigator.clipboard.writeText(orderText).then(() => {
                          copyBtn.style.backgroundColor = "#28a745";
                          copyBtn.style.color = "white";
                          copyBtn.innerText = "Copiado ✔";
                          copyBtn.disabled = true;
                        });
                      });
                    }
                  }).then(() => {
                    cleanPedido();
                  });
                }
              })
              .catch((error) => {
                console.log("Error al enviar el pedido:", error);
              });
        }
      }
    });
  };

  function isDeliveryActive(config) {
    if (!config) return false;

    if (config.idDelivery !== null && config.deliveryType !== "NO_DELIVERIES") {
      return config.deliveryType === 'COMMON'
          ? config.deliveryCommon?.active || false
          : config.deliveryType === 'CUSTOM'
              ? config.deliveryCustom?.active || false
              : false;
    }
    return false;
  }


  const sendOrder = (orderNumber) => {
    return new Promise((resolve, reject) => {
      let order = {
        id: null,
        orderNumber: orderNumber,
        ownerOrder: nameAndSuername,
        totalAmount: 0,
        tableId: 1, //setear numero de mesa que selecciono el usuario
        orderType: OrderType.WHATSAP.value,
        sendOrderType: (isDelivery && isDeliveryActive(branchConfig)) ? SendOrderType.A_DOMICILIO.value : SendOrderType.RETIRO_LOCAL.value,
        address: streetAddress,
        numberAdress: numberAddress,
        floor: floorAddress,
        department: deptoAddress,
        locality: localidadDirection,
        provinceId: 20, //ver como mando el id de la provincia
        orderDetails: [],
        orderObservation: observationsPedido,
        deliveryObservation: observationsAddress,
        shippingPrice: getDeliveryPriceBase(branchConfig),
        ruralDeliveryActive: isRuralDelivery,
        shopBranchId: selectedBranch.id // Agregamos el ID de la sucursal seleccionada
      };

      let products = getCartProducts();
      products.forEach((product) => {
        order.totalAmount += getCartLineSubtotal(product);
        order.orderDetails.push(createOrderDetail(product));
      });

      order.totalAmount = Number(order.totalAmount.toFixed(2));

      axios.post(process.env.REACT_APP_API_ORDER_CARTA_ROUTE, order, {
        params: {
          shopBranchId: selectedBranch.id
        }
      })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            const errorMessage = getApiErrorMessage(error);
            Swal.fire({
              title: 'Error con el pedido:',
              text: errorMessage,
              icon: 'error',
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false
            });
            reject(error);
          });
    });
  };

  const createOrderDetail = (product) => {
    const originalSubTotal = getCartLineOriginalSubtotal(product);
    const finalSubTotal = getCartLineSubtotal(product);
    const detail = {
      id: null,
      orderId: null,
      productId: product.id,
      productName: product.name,
      brandName: product.brandName,
      quantity: product.bulkSale ? 1 : product.cant,
      unitaryPrice: Number(product.price),
      subTotal: Number(originalSubTotal.toFixed(2)),
      finalSubTotal: Number(finalSubTotal.toFixed(2)),
    };
    if (product.bulkSale && product.bulkQuantity != null) {
      detail.bulkQuantity = product.bulkQuantity;
    }
    return detail;
  };

  const createAndSendMessagePedidoWhatsapp = (orderNumber) => {
    let totalPedido = 0;
    let mensaje = 'Hola ' + nameShopBranch + ", quiero hacerte un pedido a nombre de " + nameAndSuername.trim() + ":";

    let products = getCartProducts();

    mensaje = mensaje + `\n`;
    mensaje = mensaje + `\n`;

    let productosTexto = "";

    products.forEach((product) => {
      const lineTotal = getCartLineSubtotal(product);
      const promoDiscount = getCartPromotionDiscount(product);
      const promoLabel = product.promotion?.applied
        ? ` (${formatPromotionLabel(product.promotion.promotion)})`
        : '';
      if (product.bulkSale) {
        const qtyLabel = product.bulkQuantity != null
          ? ` (${formatBulkQuantity(product.bulkQuantity, product.measurementUnit)})`
          : '';
        productosTexto += `1X ${product.name}${qtyLabel}${promoLabel} ${formatPrice(lineTotal.toFixed(2))}\n`;
      } else {
        productosTexto += `${product.cant}X ${product.name}${promoLabel} ${formatPrice(lineTotal.toFixed(2))}\n`;
      }
      if (promoDiscount > 0) {
        productosTexto += `  Descuento promo: -${formatPrice(promoDiscount.toFixed(2))}\n`;
      }
      totalPedido += lineTotal;
    });

    if (isDelivery && isDeliveryActive(branchConfig)) {
      let priceEnvio = formatPrice(getDeliveryPriceBase(branchConfig));
      productosTexto += `ENVÍO ${formatPrice(priceEnvio)}\n`;
      totalPedido += parseFloat(priceEnvio);
    }
    mensaje += "Número de pedido: " + orderNumber;

    mensaje = mensaje + `\n`;
    mensaje = mensaje + `\n`;

    mensaje += `\Detalle del pedido:\n${productosTexto}`;

    mensaje = mensaje + `\n`;

    if (observationsPedido != null && observationsPedido != '') {
      mensaje = mensaje + "Observaciones del pedido: " + observationsPedido + ".";
      mensaje = mensaje + `\n`;
      mensaje = mensaje + `\n`;
    }

    mensaje = mensaje + "TOTAL: " + formatPrice(totalPedido);

    mensaje = mensaje + `\n`;
    mensaje = mensaje + `\n`;

    if(isDelivery && isDeliveryActive(branchConfig)){
      mensaje = mensaje + "Pedido con envio, al siguiente domicilio: " + streetAddress + " " + numberAddress + ".";
      if(floorAddress != '' && floorAddress != null){
        mensaje = mensaje + `\n`;
        mensaje = mensaje + "Piso: " + floorAddress + ".";
      }
      if(deptoAddress != '' && deptoAddress != null){
        mensaje = mensaje + `\n`;
        mensaje = mensaje + "Departamento: " + deptoAddress + ".";
      }
      if (observationsAddress != null && observationsAddress != '') {
        mensaje = mensaje + `\n`;
        mensaje = mensaje + "Observaciones de envío: " + observationsAddress + ".";
      }
    }else{
      mensaje = mensaje + "Retiro el pedido por el local.";
    }

    mensaje = mensaje + `\n`;
    mensaje = mensaje + `\n`;

    mensaje = mensaje + "¡Muchas gracias!"

    cleanPedido();
    savePendingWhatsappOrderSuccess(orderNumber);
    openWhatsAppChat(phoneShopBranch, mensaje);

    if (!isMobileDevice()) {
      showWhatsappOrderSuccessModal(orderNumber, colorshop);
    }
  }


  const cleanErrorField = (inputId, errorClass) => {
    const inputElement = document.getElementById(inputId);
    const fieldRequiredElement = document.querySelector(`.${errorClass}`);

    if (inputElement?.value) {
      fieldRequiredElement.style.display = 'none';
      inputElement.style.border = '';
    }
  };

  const cleanError = () => {
    const errorElements = [
      { error: '.errorStreetAddress', input: 'streetAddress' },
      { error: '.errorNumberAddress', input: 'numberAddress' },
      { error: '.errorLocalidadDirection', input: 'localidadDirection' }
    ];

    errorElements.forEach(({ error, input }) => {
      const fieldRequiredElement = document.querySelector(error);
      const inputElement = document.getElementById(input);

      if (fieldRequiredElement) fieldRequiredElement.style.display = 'none';
      if (inputElement) inputElement.style.border = '1px solid #ced4da';
    });
  };

  const cleanErrorSendPedidoWithoutDeliveryReset = () => {
    cleanError();
    setStreetAddress('');
    setNumberAddress('');
    setLocalidadDirection('');
    setFloorAddress('');
    setDeptoAddress('');
    setObservationsAddress('');
  };


  const cleanErrorSendPedido = () => {
    let fieldRequiredElement = document.querySelector('.errorNameAndSurname');
    if (fieldRequiredElement) {
      fieldRequiredElement.style.display = 'none';
    }

    let inputElement = document.getElementById('nameAndSurname');
    if (inputElement) {
      inputElement.style.border = '';
    }

    setNameAndSuername('');

    if (isDelivery) {
      fieldRequiredElement = document.querySelector('.errorAddressPedido');
      if (fieldRequiredElement) {
        fieldRequiredElement.style.display = 'none';
      }

      inputElement = document.getElementById('addressPedido');
      if (inputElement) {
        inputElement.style.border = '';
      }
    }
    setStreetAddress('');
    setNumberAddress('');
    setLocalidadDirection('');
    setFloorAddress('');
    setDeptoAddress('');
    setObservationsAddress('');
    setIsDelivery(false);
    setIsRuralDelivery(false);
    setIsAddressValid(false);
    setLastValidatedAddress({});
  }

  // Función para verificar si una feature específica está activa
  const isFeatureActive = (featureName) => {
    const feature = branchFeatures.find(
        (feature) => feature.name === featureName && feature.status === true
    );
    return !!feature;
  };

  const handleBackToBranchSelector = () => {
    setShowBranchSelector(true);
    setSelectedBranch(null);
    setBranchConfig(null);
    setBranchFeatures([]);
    setImageSrc('');
    setImagesBanners([]);
    setCategories([]);
    setNameShopBranch('');
    setPhoneShopBranch('');
    setAddress('');
    setLongitude('');
    setLatitude('');
    setInstagram('');
    setFacebook('');
    setPhoneNumber('');
    setColorShop('#000000');
    setProductsForCategory([]);
    setNameCategorySelected('');
    setSearchProducts([]);
    setSearchCategoriesWithProducts([]);
    setSearching(false);
    setAllProducts(true);
    setDataProductsPedidoModal([]);
    setObservationsPedido('');
    setIsDelivery(false);
    setStreetAddress('');
    setNumberAddress('');
    setLocalidadDirection('');
    setFloorAddress('');
    setDeptoAddress('');
    setObservationsAddress('');
    setIsAddressValid(false);
    setLastValidatedAddress({});
    setShippingPrice(0.0);
    setIsRuralDelivery(false);
  };

  const handleOpenProductDetail = useCallback((product) => {
    setProductDetail(product);
  }, []);

  const handleCloseProductDetail = useCallback(() => {
    setProductDetail(null);
  }, []);

  const getBranchAccentColor = (branch) => branch?.principalColorShopBranch || '#bd0000';
  const isCartaAvailable = isModuleActive(branchFeatures, MODULE_NAMES.CARTA_DISPONIBLE, true);
  const showFollowOrderScreen = isModuleActive(branchFeatures, MODULE_NAMES.SEGUIR_MI_PEDIDO, false);

  return (
      <div
        className="carta-v7"
        style={{ '--carta-accent': colorshop }}
      >
        <div className="carta-v7__shell">
        {showError ? (
            <div className="carta-v7-error">
              <h2>URL no encontrada</h2>
              <p>Lo sentimos, la URL que estás intentando acceder no existe o no está disponible.</p>
            </div>
        ) : !isLoadingFeatures && shopBranchs.length > 0 && !isCartaAvailable ? (
            <div className="carta-v7-error">
              <h2>Carta no disponible</h2>
              <p>No está disponible en este momento. Volvé a intentar más tarde.</p>
            </div>
        ) : showBranchSelector ? (
            <div className="carta-v7-branch">
              <div className="carta-v7-branch__inner">
                <h1 className="carta-v7-branch__title">Selecciona una sucursal</h1>
                <div className="carta-v7-branch__list">
                  {shopBranchs.map((branch) => {
                    const branchColor = getBranchAccentColor(branch);
                    return (
                    <div
                      key={branch.id}
                      className="carta-v7-branch-card"
                      style={{ '--carta-accent': branchColor, borderColor: branchColor }}
                    >
                      <div className="carta-v7-branch-card__body">
                        <div className="carta-v7-branch-card__name-row">
                          <span className="carta-v7-branch-card__dot" style={{ background: branchColor }} />
                          <p className="carta-v7-branch-card__name">{branch.name}</p>
                        </div>
                        <div className="carta-v7-branch-card__details">
                          <div className="carta-v7-branch-card__detail">
                            <IoLocationSharp size={14} color="#9CA3AF" />
                            <span>{branch.address}</span>
                          </div>
                          <div className="carta-v7-branch-card__detail">
                            <IoCall size={14} color="#9CA3AF" />
                            <span>{branch.phoneNumber}</span>
                          </div>
                        </div>
                        {branch.city && (
                          <div className="carta-v7-branch-card__city">{branch.city}</div>
                        )}
                        <div className="carta-v7-branch-card__action">
                          <button
                            type="button"
                            className="carta-v7-branch-card__btn"
                            style={{ background: branchColor }}
                            onClick={() => handleBranchSelection(branch)}
                          >
                            Ver carta
                          </button>
                        </div>
                      </div>
                    </div>
                    );
                  })}
                </div>
              </div>
            </div>
        ) : (
            <div className={`carta-v7-catalog${hasCartDockSpacing ? ' carta-v7-catalog--cart-dock' : ''}`}>
              {(!branchConfig?.status &&
                  <div className="aviso">
                    <p>Por el momento no se toman pedidos.</p>
                  </div>
              )}
              <div className={`carta-v7-header${!imageSrc ? ' carta-v7-header--name-only' : ' carta-v7-header--has-logo'}`}>
                <div className="carta-v7-header__back">
                  <button
                    type="button"
                    className="carta-v7-header__back-btn"
                    onClick={handleBackToBranchSelector}
                    aria-label="Volver a sucursales"
                  >
                    <IoIosArrowBack size={20} color={colorshop} />
                  </button>
                </div>
                {imageSrc ? (
                  <div className="carta-v7-header__logo-wrap">
                    <img
                      src={imageSrc}
                      alt={nameShopBranch || 'Logo'}
                      className="carta-v7-header__logo"
                      loading="eager"
                      fetchpriority="high"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        setImageSrc('');
                      }}
                    />
                  </div>
                ) : (
                  <h1 className="carta-v7-header__name">{nameShopBranch}</h1>
                )}
              </div>

              <div className="carta-v7-info-pills">
                <div className="carta-v7-info-pills__scroll hide-scrollbar">
                  {showFollowOrderScreen && (
                    <Link
                      to="/estadoDelPedido"
                      state={{ shopBranch: selectedBranch }}
                      className="carta-v7-pill carta-v7-pill--accent"
                    >
                      <IoReceiptOutline size={14} />
                      <span className="carta-v7-pill__label">Seguir mi pedido</span>
                    </Link>
                  )}
                  {phoneNumber && (
                    <a href={`tel:${phoneNumber}`} className="carta-v7-pill">
                      <IoCall size={14} />
                      <span>{phoneNumber}</span>
                    </a>
                  )}
                  {latitude && longitude && address && (
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="carta-v7-pill"
                    >
                      <IoLocationSharp size={14} />
                      <span>{address}</span>
                    </a>
                  )}
                  {instagram && (
                    <a
                      href={`https://www.instagram.com/${instagram}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="carta-v7-pill carta-v7-pill--icon"
                      aria-label="Instagram"
                    >
                      <AiFillInstagram size={16} />
                    </a>
                  )}
                  {facebook && (
                    <a
                      href={`https://www.facebook.com/${facebook}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="carta-v7-pill carta-v7-pill--icon"
                      aria-label="Facebook"
                    >
                      <FaSquareFacebook size={16} />
                    </a>
                  )}
                </div>
              </div>

              {imagesBanners.filter(b => b.urlImage).length > 0 && (
                <div className="carta-v7-banner-wrap">
                  <div className="carta-v7-banner">
                    <Carousel
                      className="carrouselCarta"
                      interval={3000}
                      controls={false}
                      indicators={true}
                      pause="hover"
                      wrap={true}
                    >
                      {imagesBanners.map((banner, index) => (
                        banner.urlImage ? (
                          <Carousel.Item key={index}>
                            <img
                              className="carta-v7-banner__img"
                              src={banner.urlImage}
                              alt={`Banner ${banner.id}`}
                              loading={index === 0 ? 'eager' : 'lazy'}
                              decoding="async"
                              fetchpriority={index === 0 ? 'high' : 'low'}
                            />
                          </Carousel.Item>
                        ) : null
                      ))}
                    </Carousel>
                  </div>
                </div>
              )}

              <div className="carta-v7-search-block">
                <div className="carta-v7-search">
                  <input
                    type="text"
                    id="nameProdSearch"
                    className="carta-v7-search__input"
                    placeholder="Buscar producto"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                  <div className="carta-v7-search__icon">
                    <Search size={16} />
                  </div>
                </div>
              </div>

              <div className="carta-v7-categories-sticky">
                <div className="carta-v7-categories">
                  {canScrollLeft && (
                    <button
                      type="button"
                      className="carta-v7-categories__arrow carta-v7-categories__arrow--left"
                      onClick={() => scrollCategories('left')}
                      aria-label="Ver categorías anteriores"
                    >
                      ‹
                    </button>
                  )}
                  <div className="carta-v7-categories__scroll hide-scrollbar" ref={categoriesRef}>
                    <button
                      type="button"
                      className={`carta-v7-cat-pill${allProducts ? ' carta-v7-cat-pill--active' : ''}`}
                      style={allProducts ? { background: colorshop, borderColor: colorshop } : {}}
                      onClick={() => {
                        fillAllProducts();
                        setAllProducts(true);
                        setNameCategorySelected('Todos los productos');
                      }}
                    >
                      <img src={iconoGenerico} alt="" className="carta-v7-cat-pill__icon" />
                      <span>Todos</span>
                    </button>
                    {categories.map((category, index) => (
                      <button
                        type="button"
                        key={category.id || index}
                        className={`carta-v7-cat-pill${!allProducts && category.name === nameCategorySelected ? ' carta-v7-cat-pill--active' : ''}`}
                        style={!allProducts && category.name === nameCategorySelected ? { background: colorshop, borderColor: colorshop } : {}}
                        onClick={() => {
                          fillProductsByIdCategorySelected(category.id);
                          setNameCategorySelected(category.name);
                          setAllProducts(false);
                        }}
                      >
                        {category.urlIcon && (
                          <img src={category.urlIcon} alt="" className="carta-v7-cat-pill__icon" />
                        )}
                        <span>{category.name}</span>
                      </button>
                    ))}
                  </div>
                  {canScrollRight && (
                    <button
                      type="button"
                      className="carta-v7-categories__arrow carta-v7-categories__arrow--right"
                      onClick={() => scrollCategories('right')}
                      aria-label="Ver más categorías"
                    >
                      ›
                    </button>
                  )}
                </div>
              </div>

              <div className="carta-v7-content hide-scrollbar">
                {isLoadingCategories ? (
                  <ProductListSkeleton count={6} />
                ) : allProducts ? (
                  searching ? (
                    searchCategoriesWithProducts && searchCategoriesWithProducts.length > 0 ? (
                      <VirtualizedProductListByCategory
                        categories={searchCategoriesWithProducts}
                        branchConfig={branchConfig}
                        onAdd={addProdPedido}
                        onMinus={minusProdPedido}
                        onProductClick={handleOpenProductDetail}
                        getProductQuantity={contProd}
                      />
                    ) : (
                      <div className="carta-v7-empty">
                        <p>No se encontraron productos para &quot;{searchTerm}&quot;</p>
                      </div>
                    )
                  ) : (
                    categories.length > 0 ? (
                      <>
                        <VirtualizedProductListByCategory
                          categories={categories}
                          branchConfig={branchConfig}
                          onAdd={addProdPedido}
                          onMinus={minusProdPedido}
                          onProductClick={handleOpenProductDetail}
                          getProductQuantity={contProd}
                        />
                        <div ref={loadMoreRef} className="carta-v7-load-more-sentinel" aria-hidden="true" />
                        {isFetchingNextPage && (
                          <ProductListSkeleton count={2} />
                        )}
                      </>
                    ) : (
                      <div className="carta-v7-empty">
                        <p>No hay categorías disponibles</p>
                      </div>
                    )
                  )
                ) : (
                  <>
                    <h2 className="carta-v7-section-title">{nameCategorySelected}</h2>
                    {searching ? (
                      searchProducts && searchProducts.length > 0 ? (
                        <VirtualizedProductList
                          products={searchProducts}
                          branchConfig={branchConfig}
                          onAdd={addProdPedido}
                          onMinus={minusProdPedido}
                          onProductClick={handleOpenProductDetail}
                          getProductQuantity={contProd}
                        />
                      ) : (
                        <div className="carta-v7-empty">
                          <p>No se encontraron productos para &quot;{searchTerm}&quot;</p>
                        </div>
                      )
                    ) : (
                      productsForCategory && productsForCategory.length > 0 ? (
                        <VirtualizedProductList
                          products={productsForCategory}
                          branchConfig={branchConfig}
                          onAdd={addProdPedido}
                          onMinus={minusProdPedido}
                          onProductClick={handleOpenProductDetail}
                          getProductQuantity={contProd}
                        />
                      ) : (
                        <div className="carta-v7-empty">
                          <p>No hay productos en esta categoría</p>
                        </div>
                      )
                    )}
                  </>
                )}
              </div>

              <div className='footer' style={{backgroundColor: colorshop}}>
                <a href="https://ucoode.com.ar/" target="_blank" rel="noopener noreferrer">
                  <img
                    src={iconoFooter}
                    alt="UCODE"
                    loading="lazy"
                    decoding="async"
                  />
                </a>
              </div>

                <div className="modal fade carta-v7-order-modal-root" id="modalProductsPedido" data-bs-backdrop="static"
                     data-bs-keyboard="false"
                     tabIndex="-1" aria-labelledby="modalProductsPedidoLabel" aria-hidden="true">
                  <div className="modal-dialog carta-v7-order-modal__dialog">
                    <div className="modal-content carta-v7-order-modal">
                      <div className="carta-v7-order-modal__header">
                        <h2 className="carta-v7-order-modal__title" id="modalProductsPedidoLabel">Tu pedido</h2>
                        <button
                          type="button"
                          className="carta-v7-order-modal__close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          id="btnCloseCarrito"
                        >
                          ×
                        </button>
                      </div>
                      <div className="carta-v7-order-modal__body">
                        {dataProductsPedidoModal.map((product) => (
                          <div key={product.cartLineId || `p-${product.id}`} className="carta-v7-order-item">
                            <div className="carta-v7-order-item__top">
                              <div className="carta-v7-order-item__info">
                                {product.brandName != null && product.brandName !== '' && (
                                  <span className="carta-v7-order-item__brand">{product.brandName}</span>
                                )}
                                <p className="carta-v7-order-item__name">{product.name}</p>
                                <p className="carta-v7-order-item__unit">
                                  {product.bulkSale
                                    ? formatPricePerUnit(product.price, product.measurementUnit)
                                    : `${formatPrice(product.price)} c/u`}
                                </p>
                                {product.bulkSale && product.bulkQuantity != null && (
                                  <p className="carta-v7-order-item__bulk-qty">
                                    {formatBulkQuantity(product.bulkQuantity, product.measurementUnit)}
                                  </p>
                                )}
                                {product.promotion?.applied && (
                                  <span className="carta-v7-order-item__promo-badge">
                                    {formatPromotionLabel(product.promotion.promotion)}
                                  </span>
                                )}
                                {product.promotion?.promotionType === 'QUANTITY_PROMOTION' && product.promotion.applied && (
                                  <p className="carta-v7-order-item__promo-hint">
                                    Llevás {product.promotion.quantitySold}, pagás {product.promotion.quantityPaid}
                                  </p>
                                )}
                              </div>
                              {branchConfig?.status && (
                                <button
                                  type="button"
                                  className="carta-v7-order-item__delete"
                                  onClick={() => deleteProductPedido(product)}
                                  aria-label="Eliminar producto"
                                >
                                  <TrashCan size={16} />
                                </button>
                              )}
                            </div>
                            {branchConfig?.status && (
                              <div className="carta-v7-order-item__controls-row">
                                {!product.bulkSale ? (
                                <div className="carta-v7-order-item__qty">
                                  <button type="button" className="carta-v7-order-item__qty-btn" onClick={() => minusProdPedido(product.id)}>
                                    <SubtractAlt size={14} />
                                  </button>
                                  <span className="carta-v7-order-item__qty-count">{product.cant}</span>
                                  <button type="button" className="carta-v7-order-item__qty-btn carta-v7-order-item__qty-btn--plus" onClick={() => addProdPedido(product)}>
                                    <span className="carta-v7-qty__plus carta-v7-qty__plus--sm">+</span>
                                  </button>
                                </div>
                                ) : (
                                  <button
                                    type="button"
                                    className="carta-v7-order-item__bulk-add"
                                    onClick={() => addProdPedido(product)}
                                    data-testid={`carta-order-bulk-add-${product.id}`}
                                  >
                                    Agregar otra porción
                                  </button>
                                )}
                                <p className="carta-v7-order-item__subtotal">
                                  {getCartPromotionDiscount(product) > 0 ? (
                                    <>
                                      <span className="carta-v7-order-item__subtotal-before">
                                        {formatPrice(getCartLineOriginalSubtotal(product).toFixed(2))}
                                      </span>
                                      Subtotal: <strong>{formatPrice(getCartLineSubtotal(product).toFixed(2))}</strong>
                                    </>
                                  ) : (
                                    <>
                                      Subtotal: <strong>{formatPrice(getCartLineSubtotal(product).toFixed(2))}</strong>
                                    </>
                                  )}
                                </p>
                              </div>
                            )}
                          </div>
                        ))}

                        <div className="carta-v7-order-modal__totals">
                          <div className="carta-v7-order-modal__total-row">
                            <span>Subtotal</span>
                            <span>{formatPrice(calcularTotal(dataProductsPedidoModal).toFixed(2))}</span>
                          </div>
                          <div className="carta-v7-order-modal__total-final">
                            TOTAL: {formatPrice(calcularTotal(dataProductsPedidoModal).toFixed(2))}
                          </div>
                        </div>

                        <label htmlFor="observationsPedido" className="carta-v7-order-modal__label">
                          Observaciones del pedido:
                        </label>
                        <textarea
                          rows="3"
                          className="carta-v7-order-modal__textarea"
                          id="observationsPedido"
                          placeholder="Ej: Sin picante, dejar en portería..."
                          value={observationsPedido}
                          onChange={(e) => setObservationsPedido(e.target.value)}
                        />
                      </div>
                      <div className="carta-v7-order-modal__footer">
                        <button
                          id="btnCloseModalAdd"
                          type="button"
                          className="carta-v7-order-modal__btn carta-v7-order-modal__btn--dark"
                          data-bs-dismiss="modal"
                          onClick={() => cleanPedidoBorrador()}
                        >
                          Borrar pedido
                        </button>
                        <button
                          id="btnSendPedidoForWhatsapp"
                          type="button"
                          className="carta-v7-order-modal__btn carta-v7-order-modal__btn--primary"
                          style={{ backgroundColor: colorshop }}
                          data-bs-dismiss="modal"
                          data-bs-toggle="modal"
                          data-bs-target="#modalDataForPedido"
                          disabled={dataProductsPedidoModal.length === 0}
                        >
                          <span className="carta-v7-order-modal__btn-icon">↗</span>
                          Pedir por Whatsapp
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal fade carta-v7-checkout-modal-root" id="modalDataForPedido" data-bs-backdrop="static"
                     data-bs-keyboard="false"
                     tabIndex="-1" aria-labelledby="modalDataForPedidoLabel" aria-hidden="true">
                  <div className="modal-dialog carta-v7-checkout-modal__dialog">
                    <div className="modal-content carta-v7-checkout-modal">
                      <div className="carta-v7-checkout-modal__header">
                        <h2 className="carta-v7-checkout-modal__title" id="modalDataForPedidoLabel">
                          Datos para finalizar tu pedido
                        </h2>
                        <button
                          type="button"
                          className="carta-v7-checkout-modal__close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          data-bs-toggle="modal"
                          data-bs-target="#modalProductsPedido"
                          onClick={() => cleanErrorSendPedido()}
                        >
                          ×
                        </button>
                        <button id="btnCloseModalPersona" hidden={true} type="button" data-bs-dismiss="modal"
                                aria-label="Close" onClick={() => cleanErrorSendPedido()}></button>
                      </div>
                      <div className="carta-v7-checkout-modal__body">

                        <div className="carta-v7-checkout-field">
                          <label htmlFor="nameAndSurname" className="carta-v7-checkout-field__label">Nombre y apellido</label>
                          <input
                            type="text"
                            className="carta-v7-checkout-field__input nameAndSuername"
                            id="nameAndSurname"
                            value={nameAndSuername}
                            onChange={(e) => {
                              setNameAndSuername(e.target.value);
                              cleanErrorField('nameAndSurname', 'errorNameAndSurname');
                            }}
                          />
                          <div className="carta-v7-checkout-field__error errorNameAndSurname" id="errorNameAndSurname">
                            Campo obligatorio
                          </div>
                        </div>

                        <div className="carta-v7-checkout-field">
                          <label htmlFor="isDeliveryTrue" className="carta-v7-checkout-field__label">Envío a domicilio</label>
                          {branchConfig && isDeliveryActive(branchConfig) ? (
                            <div className="carta-v7-checkout-radio-group">
                              <label className="carta-v7-checkout-radio" htmlFor="isDeliveryTrue">
                                <input
                                  type="radio"
                                  id="isDeliveryTrue"
                                  name="isDelivery"
                                  value="true"
                                  checked={isDelivery === true}
                                  onChange={() => setIsDelivery(true)}
                                />
                                Sí
                              </label>
                              <label className="carta-v7-checkout-radio" htmlFor="isDeliveryFalse">
                                <input
                                  type="radio"
                                  id="isDeliveryFalse"
                                  name="isDelivery"
                                  value="false"
                                  checked={isDelivery === false}
                                  onChange={() => {
                                    setIsDelivery(false);
                                    setStreetAddress('');
                                    setNumberAddress('');
                                    setLocalidadDirection('');
                                    setFloorAddress('');
                                    setDeptoAddress('');
                                    setObservationsAddress('');
                                  }}
                                />
                                No
                              </label>
                            </div>
                          ) : (
                            <>
                              <p className="carta-v7-checkout-field__hint carta-v7-checkout-field__hint--alert">
                                Por el momento no realizamos envíos, ¡retiralo en nuestro local!
                              </p>
                              <div className="carta-v7-checkout-radio-group">
                                <label className="carta-v7-checkout-radio" htmlFor="isDeliveryTrue">
                                  <input
                                    type="radio"
                                    id="isDeliveryTrue"
                                    name="isDelivery"
                                    value="true"
                                    checked={false}
                                    onChange={() => {}}
                                    disabled={true}
                                  />
                                  Sí
                                </label>
                                <label className="carta-v7-checkout-radio" htmlFor="isDeliveryFalse">
                                  <input
                                    type="radio"
                                    id="isDeliveryFalse"
                                    name="isDelivery"
                                    value="false"
                                    checked={false}
                                    onChange={() => {}}
                                    disabled={true}
                                  />
                                  No
                                </label>
                              </div>
                            </>
                          )}
                        </div>

                        {isDelivery && (
                          <>
                            <p className="carta-v7-checkout-field__hint">
                              Valor del envío:{' '}
                              {googleLocalizationFeature
                                ? shippingPrice !== 0.0
                                  ? formatPrice(shippingPrice)
                                  : 'Calculando...'
                                : formatPrice(branchConfig?.deliveryCommon?.priceBase || 0)}
                            </p>

                            {ruralSettingsFeatures?.status && branchConfig?.ruralSettings && (
                              <label className="carta-v7-checkout-checkbox" htmlFor="isRuralDelivery">
                                <input
                                  type="checkbox"
                                  id="isRuralDelivery"
                                  name="isRuralDelivery"
                                  checked={isRuralDelivery}
                                  onChange={(e) => toggleRuralDelivery(e.target.checked)}
                                />
                                Envío a dirección rural
                              </label>
                            )}

                            <div className="carta-v7-checkout-address-grid">
                              <div className="carta-v7-checkout-field carta-v7-checkout-field--street">
                                <label htmlFor="streetAddress" className="carta-v7-checkout-field__label">Calle</label>
                                <input
                                  type="text"
                                  className="carta-v7-checkout-field__input streetAddress"
                                  id="streetAddress"
                                  autoComplete="off"
                                  value={streetAddress}
                                  onChange={(e) => {
                                    setStreetAddress(e.target.value);
                                    checkAddressChange();
                                    cleanErrorField('streetAddress', 'errorStreetAddress');
                                  }}
                                  disabled={!isDeliveryActive(branchConfig) || isRuralDelivery}
                                />
                                <div className="carta-v7-checkout-field__error errorStreetAddress" id="errorStreetAddress">
                                  Campo obligatorio
                                </div>
                              </div>

                              <div className="carta-v7-checkout-field">
                                <label htmlFor="numberAddress" className="carta-v7-checkout-field__label">Número</label>
                                <input
                                  type="number"
                                  className="carta-v7-checkout-field__input numberAddress"
                                  id="numberAddress"
                                  value={numberAddress}
                                  onChange={(e) => {
                                    setNumberAddress(e.target.value);
                                    checkAddressChange();
                                    cleanErrorField('numberAddress', 'errorNumberAddress');
                                  }}
                                  disabled={!isDeliveryActive(branchConfig) || isRuralDelivery}
                                />
                                <div className="carta-v7-checkout-field__error errorNumberAddress" id="errorNumberAddress">
                                  Campo obligatorio
                                </div>
                              </div>

                              <div className="carta-v7-checkout-field carta-v7-checkout-field--wide">
                                <label htmlFor="localidadDirection" className="carta-v7-checkout-field__label">Localidad</label>
                                <input
                                  type="text"
                                  className="carta-v7-checkout-field__input localidadDirection"
                                  id="localidadDirection"
                                  value={localidadDirection}
                                  onChange={(e) => {
                                    setLocalidadDirection(e.target.value);
                                    checkAddressChange();
                                    cleanErrorField('localidadDirection', 'errorLocalidadDirection');
                                  }}
                                  disabled={!isDeliveryActive(branchConfig) || isRuralDelivery}
                                />
                                <div className="carta-v7-checkout-field__error errorLocalidadDirection" id="errorLocalidadDirection">
                                  Campo obligatorio
                                </div>
                              </div>

                              {branchConfig?.verifyAddress && (
                                <div className="carta-v7-checkout-field">
                                  <button
                                    type="button"
                                    className="carta-v7-checkout-validate-btn"
                                    onClick={() => validateAddress()}
                                    disabled={isRuralDelivery}
                                  >
                                    Validar dirección
                                  </button>
                                </div>
                              )}

                              <div className="carta-v7-checkout-field">
                                <label htmlFor="piso" className="carta-v7-checkout-field__label">Piso</label>
                                <input
                                  type="number"
                                  className="carta-v7-checkout-field__input piso"
                                  id="piso"
                                  value={!isDeliveryActive(branchConfig) ? '' : floorAddress}
                                  onChange={(e) => setFloorAddress(e.target.value)}
                                  disabled={!isDeliveryActive(branchConfig) || isRuralDelivery}
                                />
                              </div>

                              <div className="carta-v7-checkout-field">
                                <label htmlFor="depto" className="carta-v7-checkout-field__label">Depto</label>
                                <input
                                  type="text"
                                  className="carta-v7-checkout-field__input depto"
                                  id="depto"
                                  value={!isDeliveryActive(branchConfig) ? '' : deptoAddress}
                                  onChange={(e) => setDeptoAddress(e.target.value)}
                                  disabled={!isDeliveryActive(branchConfig) || isRuralDelivery}
                                />
                              </div>

                              <div className="carta-v7-checkout-field carta-v7-checkout-field--wide">
                                <label htmlFor="observations" className="carta-v7-checkout-field__label">
                                  Indicación adicional del destino
                                </label>
                                <textarea
                                  placeholder="Casa con rejas negras, sin timbre"
                                  rows="3"
                                  className="carta-v7-checkout-field__textarea observations"
                                  id="observations"
                                  value={!isDeliveryActive(branchConfig) ? '' : observationsAddress}
                                  onChange={(e) => setObservationsAddress(e.target.value)}
                                  disabled={!isDeliveryActive(branchConfig)}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="carta-v7-checkout-modal__footer">
                        <button
                          id="btnCloseModalSendPedido"
                          type="button"
                          className="carta-v7-checkout-modal__btn carta-v7-checkout-modal__btn--secondary"
                          data-bs-dismiss="modal"
                          data-bs-toggle="modal"
                          data-bs-target="#modalProductsPedido"
                          onClick={() => cleanErrorSendPedido()}
                        >
                          Volver
                        </button>
                        <button
                          type="button"
                          className="carta-v7-checkout-modal__btn carta-v7-checkout-modal__btn--primary"
                          style={{ backgroundColor: colorshop }}
                          onClick={() => sendOrderForWhatsapp()}
                        >
                          Enviar pedido
                        </button>
                      </div>
                    </div>
                  </div>
                </div>


                {/* Dock inferior: carrito + volver arriba */}
                {showBottomDock && (
                  <div className={`carta-v7-bottom-dock${cartBarMounted ? '' : ' carta-v7-bottom-dock--scroll-only'}`}>
                    {cartBarMounted && branchConfig?.status && (
                      <button
                        id="btnCarrito"
                        type="button"
                        className={`carta-v7-cart-bar${cartDockVisible ? ' carta-v7-cart-bar--visible' : ''}`}
                        data-bs-toggle="modal"
                        data-bs-target="#modalProductsPedido"
                        aria-hidden={!cartDockVisible}
                        tabIndex={cartDockVisible ? 0 : -1}
                      >
                        <div className="carta-v7-cart-bar__left">
                          <ShoppingCart size={18} />
                          <span className="carta-v7-cart-bar__count">
                            {cartItemCount} {cartItemCount === 1 ? 'producto' : 'productos'}
                          </span>
                        </div>
                        <span className="carta-v7-cart-bar__total">
                          {formatPrice(calcularTotal(cart).toFixed(2))}
                        </span>
                        <span className="carta-v7-cart-bar__cta">Ver pedido →</span>
                      </button>
                    )}
                    <button
                      type="button"
                      className={`carta-v7-bottom-dock__top${scrollTopVisible ? ' carta-v7-bottom-dock__top--visible' : ''}`}
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                      aria-label="Volver arriba"
                      aria-hidden={!scrollTopVisible}
                      tabIndex={scrollTopVisible ? 0 : -1}
                    >
                      <IoArrowUpSharp size={20} />
                    </button>
                  </div>
                )}

                <ProductDetailModal
                  product={productDetail}
                  branchConfig={branchConfig}
                  count={productDetail ? parseInt(contProd(productDetail.id) || 0) : 0}
                  onAdd={() => productDetail && addProdPedido(productDetail)}
                  onMinus={() => productDetail && minusProdPedido(productDetail.id)}
                  onClose={handleCloseProductDetail}
                />

                <CartaBulkSaleModal
                  product={bulkModalProduct}
                  show={Boolean(bulkModalProduct)}
                  onClose={() => setBulkModalProduct(null)}
                  onConfirm={confirmBulkAddToCart}
                />

            </div>
        )}
        </div>
      </div>
        );
}